import { gql } from '@eti/schema-types';

export const ORDER_QUERY = gql(/* GraphQL */ `
  query getOrderOnPostBookingPage {
    orderNew {
      customerDetails {
        email
      }
      trips {
        tripId: id
        type
        travelers {
          age
          ageType
          firstName
          gender
          id
          lastName
          fullName
        }
        bounds {
          boundId: id
          segments {
            ... on TripSegment {
              __typename
              arrivedAt
              departuredAt
              destination {
                code
                name
                cityCode
                cityName
              }
              duration
              equipmentCode
              segmentId: id
              origin {
                code
                name
                cityCode
                cityName
              }
              marketingCarrier {
                code
                name
              }
            }
          }
        }
        extraProducts {
          id
          name
          price {
            price {
              value
            }
          }
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                loungeInfo {
                  closeAt
                  loungeName
                  openAt
                  terminal
                  amenities {
                    code
                    id
                    name
                  }
                  conditions {
                    code
                    description
                  }
                }
                arrivalAirport
                available
                boundIndex
                boundType
                departureAirport
                departureDateTime
                extSystem
                flightNumber
                segmentIndex
              }
            }
          }
          buySpecification {
            ... on BuySpecificationCartTraveler {
              __typename
              travelerPrices {
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerBaggage {
              __typename
              travelerBaggageTripPrices {
                travelerId
                price {
                  price {
                    value
                  }
                }
                pieces
              }
            }
            ... on BuySpecificationCartTravelerChoice {
              __typename
              travelerChoicePrices {
                price {
                  price {
                    value
                  }
                }
                choice
                travelerId
              }
            }
            ... on BuySpecificationCartTravelerSeatMap {
              __typename
              travelerSeatMapPrices {
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerCabinBaggage {
              __typename
              travelerCabinBaggagePrices {
                pieces
                price {
                  price {
                    value
                  }
                }
              }
            }
          }
        }
        ancillaryBundles {
          id
          name
          selectedOption
          options {
            id
            name
            content {
              name
              included
              weight
              weightUnit
              pieces
              productTypeId
            }
            price {
              price {
                value
              }
            }
          }
        }
        availableExtraProducts {
          id
          name
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                loungeInfo {
                  closeAt
                  loungeName
                  openAt
                  terminal
                  amenities {
                    code
                    id
                    name
                  }
                  conditions {
                    code
                    description
                  }
                }
                arrivalAirport
                available
                boundIndex
                boundType
                departureAirport
                departureDateTime
                extSystem
                flightNumber
                segmentIndex
              }
            }
          }
          sellSpecification {
            ... on SellSpecificationSeatingSeatMapNew {
              __typename
              sellSeatMapBounds {
                id
                sellSeatMapSegments {
                  ... on SellSeatMapSegmentNew {
                    __typename
                    id
                    travelerIds
                    bestPriceCharacteristics {
                      characteristic
                      price
                    }
                    lowerDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                    mainDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                    upperDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                  }
                  ... on SellSeatingPreference {
                    __typename
                    price {
                      price {
                        value
                      }
                      markup {
                        value
                      }
                    }
                    id
                  }
                  ... on SellSeatingBeside {
                    __typename
                    price {
                      price {
                        value
                      }
                      markup {
                        value
                      }
                    }
                    id
                  }
                }
              }
            }
            ... on SellSpecificationBaggageNew {
              sellPriceBaggage {
                maxWeight
                numberOfUnits
                travelerId
                weightUnit
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on SellSpecificationTravelerNew {
              sellPriceTravelers {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on SellCabinBaggageNew {
              weight
              weightUnit
              pieces
              size3d {
                height
                length
                width
              }
              sellPriceTravelers {
                travelerId
                price {
                  price {
                    value
                    currency {
                      code
                    }
                  }
                  markup {
                    value
                    currency {
                      code
                    }
                  }
                  vat {
                    currency {
                      code
                    }
                    value
                  }
                }
              }
            }
            ... on SellSpecificationTravelerChoiceNew {
              availableChoices {
                id
                name
                descriptions {
                  text
                  type
                }
                pricePerTravelers {
                  price {
                    price {
                      value
                    }
                  }
                  travelerId
                }
              }
              preselectedChoice
              pricePerTravelers {
                price {
                  price {
                    value
                  }
                }
                travelerId
              }
            }
            ... on SellSpecificationNoneNew {
              price {
                price {
                  value
                }
              }
            }
          }
          configuration {
            postbookingAncillaryStore {
              persuasionEnabled
              showPricePerBound
              showPricePerTraveler
              highlightProduct
            }
            productPreSelection
          }
        }
      }
      addOnOrders {
        extraProducts {
          id
          code
          name
          price {
            price {
              value
            }
          }
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                loungeInfo {
                  closeAt
                  loungeName
                  openAt
                  terminal
                  amenities {
                    code
                    id
                    name
                  }
                  conditions {
                    code
                    description
                  }
                }
                arrivalAirport
                available
                boundIndex
                boundType
                departureAirport
                departureDateTime
                extSystem
                flightNumber
                segmentIndex
              }
            }
          }
          buySpecification {
            ... on BuySpecificationCartTraveler {
              __typename
              travelerPrices {
                travelerId
              }
            }
            ... on BuySpecificationCartTravelerBaggage {
              __typename
              travelerBaggageTripPrices {
                travelerId
                pieces
              }
            }
            ... on BuySpecificationCartTravelerChoice {
              __typename
              travelerChoicePrices {
                travelerId
              }
            }
            ... on BuySpecificationCartTravelerSeatMap {
              __typename
            }
            ... on BuySpecificationCartTravelerCabinBaggage {
              __typename
              travelerCabinBaggagePrices {
                travelerId
                pieces
              }
            }
          }
        }
      }
    }
  }
`);
